import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import {
  getCurrentWeekString,
  getPreviousWeek,
  getNextWeek,
  getWeekTitle,
  getWeekDateRange,
  formatHours,
} from '../my-hours.utils';

interface WeekNavigationProps {
  week: string;
  totalHours?: number;
}

export function WeekNavigation({ week, totalHours }: WeekNavigationProps) {
  const previousWeek = getPreviousWeek(week);
  const nextWeek = getNextWeek(week);
  const currentWeek = getCurrentWeekString();
  const isCurrentWeek = week === currentWeek;
  const isFutureWeek = week > currentWeek;

  return (
    <div className="mb-6 flex items-center justify-between">
      {/* Navigation */}
      <div className="flex items-center gap-2">
        <Button variant="outline" size="icon" asChild tooltip={false}>
          <Link to={`/my-hours/${previousWeek}`}>
            <ChevronLeft className="h-4 w-4" />
          </Link>
        </Button>

        <div className="text-center">
          <div className="font-semibold">{getWeekTitle(week)}</div>
          <div className="text-muted-foreground text-xs">
            {getWeekDateRange(week)}
          </div>
        </div>

        <Button
          variant="outline"
          size="icon"
          asChild
          tooltip={false}
          disabled={isFutureWeek}
        >
          <Link to={`/my-hours/${nextWeek}`}>
            <ChevronRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>

      {/* Week total + today button */}
      <div className="flex items-center gap-4">
        <div className="text-right">
          <div className="text-muted-foreground text-xs">Week total</div>
          {totalHours !== undefined ? (
            <div className="text-lg font-semibold">
              {formatHours(totalHours)}
            </div>
          ) : (
            <Skeleton className="mt-1 h-6 w-12" />
          )}
        </div>

        {!isCurrentWeek && (
          <Button variant="outline" size="sm" asChild tooltip={false}>
            <Link to={`/my-hours/${currentWeek}`}>Today</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
